module.exports = __webpack_public_path__ + "img/wave-1.fe908b95.svg";